import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/index';
import { Footer, SEO } from './components';
import { SITE_URL } from './components/SEO';
import Header from './components/Header';
import Contact from './pages/Contact';
import RequestDemo from './pages/RequestDemo';
import ThankYouDemo from './pages/ThankYouDemo';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './styles/tokens.css';
import './styles/index.css';
import Product from './pages/Product';
import Solutions from './pages/Solutions';
import Industries from './pages/Industries';
import About from './pages/About';

// Sitewide Organization structured data — helps Google understand the brand
// and can power a knowledge-panel / sitelinks searchbox for "OpenUse" queries.
const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OpenUse',
  legalName: 'Stargrid Technologies, Inc.',
  url: SITE_URL,
  logo: `${SITE_URL}/images/brand/logo.png`,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'San Mateo',
    addressRegion: 'CA',
    addressCountry: 'US',
  },
};

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <SEO
          title="OpenUse"
          description="OpenUse builds mobile-first operational software — SupplyMD, OpenRFQ, AInventory, and ATracker — for procurement and inventory teams in healthcare and SMB operations."
          path="/"
          structuredData={organizationJsonLd}
        />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/product" element={<Product />} />
          <Route path="/product/:slug" element={<Product />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/request-demo" element={<RequestDemo />} />
          <Route path="/request-demo/thank-you" element={<ThankYouDemo />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
};

export default App;